module.exports = __webpack_public_path__ + "static/img/win_seal.fcac0740.png";